import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import ReactSVG from "react-svg";
import ClickOutsideHolder from "../ClickOutsideHolder";

import cx from "classnames";
import { withTranslation } from "react-i18next";
import { get, isEmpty } from "lodash";
import SmartPortal from "../SmartPortal";

// @TODO move NotificationTypes to the parent (drill it down to get rid of dependency)
import { NotificationTypes } from "constants/index";

import "./styles.scss";

/*
   FieldController props:
        * value => current value of field
        * savedValue => saved value of field
        * change => function for changing field value by key (used for resetField action), currently from redux-form
        * handleLiveSubmit => function for handling save request, incoming args: 
            - key => field key
            - responseCallback => callBack for request response (handleResponse function)
        * loader => field loader component 
        * autoSave => boolean for saving field without confirming action on isDirty flag (blur, enter, button click)
        * enterDisabled => boolean for removing submit on enter key (textarea for example)
*/

// const CONTROLER_HEIGHT = 32;
// const CONTROLER_CHEVRON_HEIGHT = 12;
// const INPUT_HEIGHT = 30;
// const LABEL_HEIGHT = 17;

// const CHEVRON_SIZE = 14;
// const CONTAINER_WIDTH = 96;
// const CONTAINER_BUTTON_WIDTH = 30; // width + margin
// const CONTAINER_PADDING = 6;

// const SCROLL_TIMEOUT = 100;

// const INPUT_CONTROLLER_DIFFERENCE = 2;

const COPY_DOM_INPUT_VALUE_TYPES = ["date", "datetime"];
const COPY_DOM_SPAN_INPUT_VALUE_TYPES = ["cust_address"];
const DATES_WIDGETS = ["date", "datetime"];

const CUSTOM_ERRORS_WIDGETS = ["fileMultiple", "fileSingle", "radio"];

const WIDGETS_WITH_NO_SELECT_OPTIONS_CHECK = ["multiselect"];
const WIDGETS_WITH_MODAL = ["cust_address"];

const WIDGETS_WITH_DISABLED_VALUE_PREVIEW = ["input"];

const FieldController = props => {
    const {
        t,
        widgetType,
        widgetStyleClass,
        fieldKey,
        value,
        initValue,
        change,
        error,
        handleLiveSubmit,
        loader,
        autoSave,
        enterDisabled,
        clearable = true,
        disabled,
        portalPlacement = "right",
        children,
        showNotification = () => {},
        selectOptions,
        isSaveOnlyValid,
        isForceDirtyToPristine,
        onDirtyReset,
        preventErrorRender,
        onIsFocused,
        isForceToSubmit,
        setIsForceToSubmit,
        required,
        // extraTopOffset = 0, // currently used for top offset calculation in SelectTree, probably should be removed once FieldController is migrated to SmartPortal
        isForceHiddenController,
        hasExValue,
        onFieldChange,
        customOuterYOffset,
    } = props;

    const isStringifyValue = get(props, "children.props.isStringifyValue");

    const isStringifyAttrValue = get(props, "children.props.isStringifyAttrValue");

    const [isLoading, setIsLoading] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    // const [initialValue, setInitialValue] = useState(value);
    const [initialValue, setInitialValue] = useState(initValue);

    // const [isReversed, setIsReversed] = useState(false);

    // const [portalPosition, setPortalPosition] = useState(null);
    const [calculatedPosition, setCalculatedPosition] = useState({});
    const [isVisited, setIsVisited] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
    // const [isScrolling, setIsScrolling] = useState(false);
    // const [scrollTimeout, setScrollTimeout] = useState(null);
    // const showControlls =
    //     !disabled && !isScrolling && !isLoading && !autoSave && (isFocused || isDirty || error);
    // const showControlls = !disabled && !isScrolling && !isLoading && !autoSave && isFocused; // prev logic

    const isEmptyValue = typeof value === "object" ? isEmpty(value) : [null, undefined, ""].includes(value);
    // const isAnyControllActive = !isEmpty(value) || isDirty;
    const isAnyControllActive = !isEmptyValue || isDirty;

    // we should able to submit required widget with an empty value (UI will still show the validation error, but the value will be saved)
    const isEmptyRequiredWidget = required && isEmptyValue;

    // const showSaveControl = isSaveOnlyValid ? !error : true;
    let showSaveControl = true;
    if (isSaveOnlyValid) {
        if (error && !isEmptyRequiredWidget) {
            showSaveControl = false;
        }
    }

    // const [controllerParent, setControllerParent] = useState(null);
    // const [controllerParentSticky, setControllerParentSticky] = useState(null);
    // const [controllerLabel, setControllerLabel] = useState(null);
    const [controllerLabelHeight, setControllerLabelHeight] = useState(0);
    const [isResetAvailable, setIsResetAvailable] = useState(true);
    const controllerRef = useRef(null);

    const isClearVisible =
        (Array.isArray(initialValue) ? value && value.length !== 0 : value) && !disabled && !!clearable;
    const isResetVisible = !disabled && isDirty && isResetAvailable;
    const isCopyVisible = Array.isArray(initialValue) ? value && value.length !== 0 : value;
    const isSubmitVisible = isDirty && handleLiveSubmit && !disabled && showSaveControl;

    const isAnyControllVisible = isClearVisible || isResetVisible || isCopyVisible || isSubmitVisible;
    // new showControlls logic - make sure that also at least one controll action btn is visible
    // const showControlls = isAnyControllVisible && !disabled && !isLoading && !autoSave && isFocused;
    const showControlls = isAnyControllVisible && !isLoading && !autoSave && isFocused;

    // let calculatedContainerWidth = 0;
    // if (isClearVisible) {
    //     calculatedContainerWidth += CONTAINER_BUTTON_WIDTH;
    // }
    // if (isResetVisible) {
    //     calculatedContainerWidth += CONTAINER_BUTTON_WIDTH;
    // }
    // if (isCopyVisible) {
    //     calculatedContainerWidth += CONTAINER_BUTTON_WIDTH;
    // }
    // if (isSubmitVisible) {
    //     calculatedContainerWidth += CONTAINER_BUTTON_WIDTH;
    // }
    // if (calculatedContainerWidth > CONTAINER_BUTTON_WIDTH) {
    //     calculatedContainerWidth += CONTAINER_PADDING;
    // }

    // const calculatedPosition = useMemo(() => {
    //     if (!portalPosition) {
    //         return {};
    //     }
    //     // const fieldLabel = controllerRef.current.querySelector('.input-label');
    //     let labelHeight = 0;
    //     if (controllerLabel) {
    //         labelHeight = controllerLabel.getBoundingClientRect().height;
    //         const styles = getComputedStyle(controllerLabel);
    //         const marginBottom = parseInt(styles.getPropertyValue("margin-bottom"));
    //         if (marginBottom) {
    //             labelHeight = labelHeight + marginBottom;
    //         }
    //     }
    //     if (portalPlacement === "top") {
    //         // handle top
    //         return {
    //             // top: portalPosition.top - INPUT_HEIGHT,
    //             // top: portalPosition.top - labelHeight,
    //             top: portalPosition.top - CONTROLER_HEIGHT - extraTopOffset,
    //             left: portalPosition.right - calculatedContainerWidth,
    //         };
    //     }
    //     if (portalPlacement === "right") {
    //         // handle right
    //         // check if need to reverse to the left
    //         const windowWidth = window.innerWidth;
    //         const rightPosition = portalPosition.right + CHEVRON_SIZE + calculatedContainerWidth;
    //         const isOverflowRight = rightPosition > windowWidth;
    //         if (isOverflowRight) {
    //             return {
    //                 top: portalPosition.top - INPUT_CONTROLLER_DIFFERENCE + labelHeight - extraTopOffset,
    //                 left: portalPosition.left - calculatedContainerWidth - CHEVRON_SIZE,
    //                 isReverse: true,
    //             };
    //         }
    //         // ok to render to the right
    //         return {
    //             // top: portalPosition.bottom - INPUT_HEIGHT,
    //             // top: portalPosition.top - LABEL_HEIGHT,
    //             top: portalPosition.top - INPUT_CONTROLLER_DIFFERENCE + labelHeight - extraTopOffset,
    //             left: portalPosition.right + CHEVRON_SIZE,
    //         };
    //     }

    //     if (portalPlacement === "left") {
    //         // handle left
    //         // check if need to reverse to the right
    //         const leftPosition  = portalPosition.left - calculatedContainerWidth - CHEVRON_SIZE - calculatedContainerWidth;
    //         const isOverflowLeft = leftPosition < 0;
    //         if (isOverflowLeft) {
    //             return {
    //                 // top: portalPosition.bottom - INPUT_HEIGHT,
    //                 // top: portalPosition.top - LABEL_HEIGHT,
    //                 top: portalPosition.top - INPUT_CONTROLLER_DIFFERENCE + labelHeight - extraTopOffset,
    //                 left: portalPosition.right + CHEVRON_SIZE,
    //                 isReverse: true,
    //             };
    //         }
    //         return {
    //             // top: portalPosition.bottom - INPUT_HEIGHT,
    //             // top: portalPosition.top - LABEL_HEIGHT,
    //             top: portalPosition.top - INPUT_CONTROLLER_DIFFERENCE + labelHeight - extraTopOffset,
    //             left: portalPosition.left - calculatedContainerWidth - CHEVRON_SIZE,
    //         };
    //     }
    //     return portalPosition;
    // }, [portalPosition, isClearVisible, isResetVisible, isCopyVisible, isSubmitVisible, controllerLabel]);

    // const isVisible = (ele, container, stickyContainer, withTopExtraHeight) => {
    //     const { bottom: elementBottom, top: elementTop } = ele.getBoundingClientRect();
    //     // const { bottom: elementBottom, height, top: elementTop } = ele.getBoundingClientRect();
    //     const height = CONTROLER_HEIGHT + CONTROLER_CHEVRON_HEIGHT;
    //     const containerRect = container.getBoundingClientRect();
    //     let stickyContainerHeight = 0;
    //     if (stickyContainer) {
    //         stickyContainerHeight = stickyContainer.getBoundingClientRect().height;
    //         // console.log({ stickyContainerHeight });
    //     }
    //     let top = ["right", "left"].includes(portalPlacement)
    //         ? elementTop - height / 2 - stickyContainerHeight - CONTROLER_CHEVRON_HEIGHT
    //         : elementTop - height - stickyContainerHeight;
    //     let bottom = elementBottom + CONTROLER_HEIGHT;

    //     if (withTopExtraHeight) {
    //         top = top + CONTROLER_HEIGHT;
    //         // bottom = bottom - CONTROLER_HEIGHT;
    //     }

    //     if (extraTopOffset) {
    //         top = top + extraTopOffset
    //     }

    //     return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
    // };

    // const isPortalVisible = useMemo(() => {
    //     if (controllerRef && controllerRef.current && controllerParent) {
    //         return isVisible(controllerRef.current, controllerParent, controllerParentSticky);
    //     }
    // }, [calculatedPosition, controllerRef, controllerParent, controllerParentSticky]);

    // const isCalendarVisible = useMemo(() => {
    //     if (widgetType && !widgetType.startsWith("date")) {
    //         return;
    //     }
    //     if (controllerRef && controllerRef.current && controllerParent) {
    //         return isVisible(controllerRef.current, controllerParent, controllerParentSticky, true);
    //     }
    // }, [calculatedPosition, controllerRef, controllerParent, controllerParentSticky]);

    // if (fieldKey === 'lastName' || fieldKey === 'firstName') {
    //     console.log({ isScrolling, showControlls, isAnyControllActive, fieldKey, isPortalVisible });
    //     // console.log({ fieldKey, isScrolling, isLoading, autoSave, isFocused, isDirty, error });
    // }

    // const [datePickerTarget, setDatePickerTarget] = useState(null);

    const handleResponse = (success, isFromResponse) => {
        // update initial value if response succeeded
        if (success) {
            setInitialValue(value);
            setIsDirty(false);
            setIsFocused(false);
        } else {
            // revert to initialValue if response failed and coming from the actual response
            if (isFromResponse) {
                change([fieldKey], initialValue);
            }
        }
        setIsLoading(false);
        if (isForceToSubmit && setIsForceToSubmit && typeof setIsForceToSubmit === "function") {
            setIsForceToSubmit(false);
        }
    };

    const submitField = forceSubmit => {
        if (isLoading || isWidgetModalOpen) {
            return;
        }
        if (!handleLiveSubmit) {
            return;
        }
        if (isSaveOnlyValid) {
            // we should able to submit required widget with an empty value (UI will still show the validation error, but the value will be saved)
            if (error && !isEmptyRequiredWidget) {
                return;
            }
        }
        if (isDirty || forceSubmit) {
            setIsLoading(true);
            // console.log({fieldKey, props, isStringifyValue});
            handleLiveSubmit(fieldKey, handleResponse, isStringifyAttrValue);
        }
    };

    const resetField = () => {
        if (onFieldChange && typeof onFieldChange === "function") {
            // (event, newValue, previousValue, name)
            onFieldChange("fieldControllerResetEvent", initialValue, value, fieldKey);
        }
        change([fieldKey], initialValue);
    };

    const clearField = () => {
        const resetValue = Array.isArray(initialValue) ? [] : null;
        // handle onFieldChange trigger if it is available inside of children props
        // for example to trigger lock appeal
        if (
            props.children &&
            props.children.props &&
            props.children.props.onFieldChange &&
            typeof props.children.props.onFieldChange === "function"
        ) {
            props.children.props.onFieldChange(resetValue);
        }

        if (onFieldChange && typeof onFieldChange === "function") {
            // (event, newValue, previousValue, name)
            onFieldChange("fieldControllerClearEvent", resetValue, initValue, fieldKey);
        }

        change([fieldKey], resetValue);
    };

    const getCopyValue = useCallback(() => {
        let copyValue = value;
        if (value && typeof value === "object" && !Array.isArray(value)) {
            if (value && value.label) {
                copyValue = value.label;
            } else {
                copyValue = JSON.stringify(value);
            }
        }

        // copy value for select/combo etc
        // we should exclude COPY_DOM_SPAN_INPUT_VALUE_TYPES to not process theirs selectOptions
        if (!COPY_DOM_SPAN_INPUT_VALUE_TYPES.includes(widgetType) && selectOptions && selectOptions.length > 0) {
            const valueToCheck = value && typeof value === "object" ? value.value : value;
            const option = selectOptions.find(option => option.value === valueToCheck);
            copyValue = option ? option.label : value;
        }

        // copy value for date/datetime or whatever from document input element
        if (COPY_DOM_INPUT_VALUE_TYPES.includes(widgetType) && controllerRef && controllerRef.current) {
            const input = controllerRef.current.querySelector('input[name="' + fieldKey + '"]');
            // const input = document.querySelector('input[name="' + fieldKey + '"]');
            if (input) {
                copyValue = input.value;
            }
        }

        // copy value for cust_address sor whatever from document span element
        if (COPY_DOM_SPAN_INPUT_VALUE_TYPES.includes(widgetType) && controllerRef && controllerRef.current) {
            const span = controllerRef.current.querySelector('span[name="' + fieldKey + '"]');
            if (span) {
                copyValue = span.innerText;
            }
        }

        // map array values with options labels
        if (Array.isArray(value)) {
            if (selectOptions) {
                copyValue = value.map(item => {
                    // try to find an option and return either its label or item as it was
                    const findedOption = selectOptions.find(option => option.value === item);
                    if (findedOption) {
                        return findedOption.label;
                    }
                    return item;
                });
            }
            // try to get label from copyValue
            return copyValue
                .map(val => (val && typeof val === "object" && "label" in val ? val.label : val))
                .join(", ");
        }
        if (value && widgetType === "selectTreeModalWithSearch") {
            return value.fullLabelPath || value.name;
        }
        return get(copyValue, "label", copyValue);
    }, [isFocused, isDirty, fieldKey, selectOptions, value, widgetType, controllerRef.current]);

    const valueToCopy = useMemo(() => {
        return getCopyValue();
    }, [getCopyValue]);

    const handleCopyValue = () => {
        const copyValue = getCopyValue();
        // let copyValue = typeof value === 'object' ? JSON.stringify(value) : value;

        // if (clipboard) {
        navigator.clipboard.writeText(copyValue).then(
            () => {
                console.info("FieldController::handleCopyValue: Copying to clipboard was successful!");
                showNotification({
                    type: NotificationTypes.SUCCESS,
                    options: { message: `${t("copyToClipboardSuccess")}` },
                });
            },
            err => {
                console.error("FieldController::handleCopyValue: Could not copy to clipboard: ", err);
                showNotification({
                    type: NotificationTypes.HTTP_ERROR,
                    options: { message: `${t("copyToClipboardFailure")}` },
                });
            }
        );
    };

    const handleKeyDown = e => {
        if (e.keyCode === 9 && isFocused) onClickOutside(); // TAB
        if (e.keyCode === 13 && !enterDisabled) submitField(); // ENTER
        if (e.keyCode === 27) resetField(); // ESCAPE
    };

    // const updateRefPosition = () => {
    //     if (controllerRef && controllerRef.current) {
    //         const controllerRect = controllerRef.current.getBoundingClientRect();
    //         const { top, bottom, right, left } = controllerRect;
    //         setPortalPosition({ top, bottom, right, left });
    //     } else {
    //         console.error("FieldController::updateRefPosition: ref current is not yet available");
    //     }
    // };

    // const handleScroll = useCallback(event => {
    //     const target = event.target;
    //     // prevent scroll trigger on input scroll
    //     if (target && target.tagName === "INPUT") {
    //         return;
    //     }
    //     updateRefPosition();

    //     // setTimeout(() => {
    //     //     setIsScrolling(true);
    //     // }, SCROLL_TIMEOUT / 2);
    //     // // setIsScrolling(true);
    //     // setScrollTimeout(clearTimeout(scrollTimeout));
    //     // setScrollTimeout(
    //     //     setTimeout(() => {
    //     //         setIsScrolling(false);
    //     //         updateRefPosition();
    //     //     }, SCROLL_TIMEOUT)
    //     // );
    // }, []);

    // const findControllerParent = () => {
    //     if (controllerRef && controllerRef.current) {
    //         let offsetParent = controllerRef.current.offsetParent;
    //         while (offsetParent) {
    //             const styles = getComputedStyle(offsetParent);
    //             const overflow = styles.getPropertyValue("overflow");
    //             if ((overflow && overflow.includes("auto")) || overflow.includes("scroll")) {
    //                 break;
    //             }
    //             offsetParent = offsetParent.offsetParent;
    //         }
    //         setControllerParent(offsetParent || document.body);
    //     }
    // };

    const findControllerLabelHeight = () => {
        if (controllerRef && controllerRef.current) {
            const fieldLabel = controllerRef.current.querySelector(".input-label");
            if (fieldLabel) {
                const { height } = fieldLabel.getBoundingClientRect();
                setControllerLabelHeight(height);
            }
            // setControllerLabel(fieldLabel);
        }
    };

    // const findControllerParentSticky = element => {
    //     if (element) {
    //         let children = Array.from(element.children);
    //         while (children.length) {
    //             const child = children.shift();
    //             const styles = getComputedStyle(child);
    //             const position = styles.getPropertyValue("position");
    //             if (position && position === "sticky") {
    //                 setControllerParentSticky(child);
    //                 break;
    //             }
    //             if (child.children) {
    //                 children = [...children, ...child.children];
    //             }
    //         }
    //     }
    // };

    const handleFocus = e => {
        if (isLoading || isWidgetModalOpen) {
            return;
        }
        if (typeof props.handleFocus === "function" && props.handleFocus) {
            props.handleFocus(e);
        }

        findControllerLabelHeight(); // always recalculate label height since it could be different on each focus (for example label width change which could case new lines)
        setIsFocused(true);
    };

    const blurAll = () => {
        if (controllerRef.current) {
            const tmp = document.createElement("input");
            controllerRef.current.appendChild(tmp);
            tmp.focus();
            controllerRef.current.removeChild(tmp);
        }
    };

    // handle when click on some element inside which should trigger unfocus
    // for example in textarea once preview mode is clicked => field should be unfocused
    const handleForceUnfocusClick = e => {
        if (isFocused) {
            let isForceUnfocus = false;

            const path = e ? e.path || (e.composedPath && e.composedPath()) : [];
            for (let i = 0; i < path.length; i++) {
                if (path[i].getAttribute && path[i].getAttribute("data-controler-force-unfocus")) {
                    isForceUnfocus = path[i].getAttribute("data-controler-force-unfocus") === "true";
                    break;
                }
            }

            if (isForceUnfocus) {
                // setIsVisited(true);
                setIsFocused(false);
            }
        }
    };

    const onClickOutside = e => {
        if (isFocused) {
            if (typeof props.handleBlur === "function" && props.handleBlur) {
                props.handleBlur(e);
            }
            setIsVisited(true);
        }
        let isFieldControllerParent = false;
        let isFieldControllerSubmit = false; // is field controller submit button clicked
        let isPathContainsInputField = false;

        const path = e ? e.path || (e.composedPath && e.composedPath()) : [];
        for (let i = 0; i < path.length; i++) {
            const el = path[i];
            if (el.getAttribute && el.getAttribute("data-field-controller-submit")) {
                isFieldControllerSubmit = el.getAttribute("data-field-controller-submit") === "true";
                // break;
            }
            if (el.getAttribute && el.getAttribute("data-field-key")) {
                isFieldControllerParent = el.getAttribute("data-field-key") === fieldKey;
                // break;
            }

            // ✅ Check if element is input, select, textarea or it has field-controller class
            if (el.classList && el.classList.contains("field-controller")) {
                isPathContainsInputField = true;
            }
            if (el.tagName && ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName)) {
                isPathContainsInputField = true;
            }
        }
        if (isFieldControllerParent) {
            if (isFieldControllerSubmit && isFocused) {
                setIsFocused(false);
                submitField();
                if (!isPathContainsInputField) {
                    // we need to blur everything if no input field is in path
                    // in such way we could bypass scrollbar click issue (when field was not blurred upon scrollbar click)
                    blurAll();
                }
            }
            return;
        }
        if (isFocused) {
            submitField();
            if (!isPathContainsInputField) {
                // we need to blur everything if no input field is in path
                // in such way we could bypass scrollbar click issue (when field was not blurred upon scrollbar click)
                blurAll();
            }
        }
        setIsFocused(false);
    };

    useEffect(() => {
        if (Array.isArray(value) && Array.isArray(initialValue)) {
            const isSomeInitMissed = initialValue.some(item => !value.includes(item));
            const isSomeAdded = value.some(item => !initialValue.includes(item));
            if (isSomeInitMissed || isSomeAdded) {
                return setIsDirty(true);
            }
            return setIsDirty(false);
        }
        if ([null, "", undefined].includes(value) && [null, "", undefined].includes(initialValue)) {
            return setIsDirty(false);
        }
        if (DATES_WIDGETS.includes(widgetType)) {
            // extra check for dates values (compare parsed values)
            const parsedVal = +value;
            const parsedInitVal = +initialValue;
            // perhaps use in future not strict != comparison operator
            if (value !== initialValue && parsedVal !== parsedInitVal) {
                return setIsDirty(true);
            }
        } else {
            if (hasExValue && typeof value === "object") {
                const val = value && value.value;
                const initVal = initialValue && typeof initialValue === "object" ? initialValue.value : initialValue;
                if (val !== initVal) {
                    return setIsDirty(true);
                }
                return;
            }
            // default case
            if (value !== initialValue) {
                return setIsDirty(true);
            }
        }
        setIsDirty(false);
    }, [value]);

    useEffect(() => {
        // handle FileInput, Rank and Radio autosave without buttons
        if (isDirty && autoSave) {
            setIsDirty(false);
            submitField(true);
        }
        // if (isDirty) {
        //     console.log({ isDirty, fieldKey, initialValue, value });
        // }
        // console.log({ isDirty, fieldKey, initialValue, value });
    }, [isDirty, autoSave]);

    useEffect(() => {
        // handle force to submit cases (for example when gear button is clicked - make an auto save)
        if (isForceToSubmit) {
            submitField(true);
        }
    }, [isForceToSubmit]);

    // useEffect(() => {
    //     if (controllerParent) {
    //         findControllerParentSticky(controllerParent);
    //     }
    // }, [controllerParent]);

    // useEffect(() => {
    //     return () => {
    //         document.removeEventListener("scroll", handleScroll, true);
    //     };
    // }, []);

    useEffect(() => {
        // if (isFocused) {
        //     if (onIsFocused && typeof onIsFocused === 'function') {
        //         onIsFocused();
        //     }
        // }

        if (onIsFocused && typeof onIsFocused === "function") {
            onIsFocused(isFocused);
        }
    }, [isFocused]);

    // force field to reset its dirty state (almost "reinit"),
    // for cases like "refKey" widgets (widgets which values/options are depending on values of others widgets)
    useEffect(() => {
        if (isDirty && isForceDirtyToPristine) {
            setInitialValue(value);
            setIsDirty(false);
            if (onDirtyReset && typeof onDirtyReset === "function") {
                onDirtyReset();
            }
        }
    }, [isForceDirtyToPristine, isDirty]);

    // make a check for initValue to be available in selectOptions
    // added to handle properly the case when value is changed, but initValue is no more available in selectOptions
    // initially added to handle properly appeal 'destination' field (type change caused destination value and options change)
    useEffect(() => {
        // ignore some widgets for the check, for example 'multiselect'
        // with saved value / initialValue as an array type there no need in check
        if (WIDGETS_WITH_NO_SELECT_OPTIONS_CHECK.includes(widgetType)) {
            return;
        }
        // ignore if initialValue is an array (extra additional check to the top one, in case some array value based widgets are added)
        if (initialValue && Array.isArray(initialValue)) {
            return;
        }
        // ignore if initialValue is empty
        if ([null, undefined, ""].includes(initialValue)) {
            return;
        }
        // check if initialValue is still available in selectOptions
        if (isDirty && selectOptions && Array.isArray(selectOptions)) {
            const isResetValueAvailable = selectOptions.find(option => {
                if (typeof option === "object") {
                    return option.value === initialValue || option.id === initialValue || option.key === initialValue;
                }
                return option === initialValue;
            });
            // console.log({selectOptions, value, isResetValueAvailable, widgetType});
            // no reset value is available, set current value as initialValue and reset dirty state
            if (!isResetValueAvailable) {
                // setInitialValue(value);
                // setIsDirty(false);
                setIsResetAvailable(false);
            } else {
                setIsResetAvailable(true);
            }
        }
    }, [selectOptions, isDirty]);

    useEffect(() => {
        if (isWidgetModalOpen) {
            setIsFocused(false);
        }
        if (!isWidgetModalOpen && isDirty) {
            setIsFocused(true);
        }
    }, [isWidgetModalOpen]);

    // useEffect(() => {
    //     if ('isForceHiddenController' in props && isFocused && !isForceHiddenController) {
    //         updateRefPosition();
    //     }
    // }, [isForceHiddenController]);

    // extend children with disabled via isLoading state;
    const childrenWithProps = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a
        // typescript error too.
        if (React.isValidElement(child)) {
            const childProps = { disabled: child.props.disabled || isLoading };
            if (widgetType && widgetType.startsWith("date")) {
                // console.log({isCalendarVisible});
                // childProps.isCalendarVisible = isCalendarVisible;
                childProps.isCalendarVisible = calculatedPosition.isVisible;
            }
            if (widgetType && WIDGETS_WITH_MODAL.includes(widgetType)) {
                childProps.onModalOpen = setIsWidgetModalOpen;
            }
            return React.cloneElement(child, childProps);
        }
        return child;
    });

    let calculatedPortalPlacement = portalPlacement;
    if (calculatedPosition.isReversed) {
        if (portalPlacement === "right") {
            calculatedPortalPlacement = "left";
        }
        if (portalPlacement === "left") {
            calculatedPortalPlacement = "right";
        }
        // controller placement on top is not used anymore - we moved to left/right instead
        if (portalPlacement === "top") {
            calculatedPortalPlacement = "bottom";
        }
        if (portalPlacement === "bottom") {
            calculatedPortalPlacement = "top";
        }
    }

    function onPositionUpdate(position) {
        setCalculatedPosition(position);
    }

    // const showFieldControllerActions = !isForceHiddenController && showControlls && isAnyControllActive;
    // we need to rely on isFocused for calendar fields in order to calculate the visibility of the calendar container (which is bind to SmartPortal visibility/position)
    // otherwise date/datetime fields with no values (no controlers actions and as a result - no SmartPortal rendered) - ended up visible ouside of the parent container since onPositionUpdate never fired
    const isCalendarField = widgetType && widgetType.startsWith("date");
    const showFieldControllerActions = isCalendarField
        ? isFocused && !isForceHiddenController
        : !isForceHiddenController && showControlls && isAnyControllActive;

    // const showDisabledPreviewValue =
    //     disabled && WIDGETS_WITH_DISABLED_VALUE_PREVIEW.includes(widgetType) && valueToCopy && isFocused;

    const defaultYOffset = DATES_WIDGETS.includes(widgetType)
        ? -1 * controllerLabelHeight
        : -1 * controllerLabelHeight + 5; // top position => 5px is approx size of the chevron/triangle
    const adjustedControllerLabelHeight = controllerLabelHeight ? controllerLabelHeight + 5 : 2;

    return (
        <ClickOutsideHolder
            className="field-controller-outside-holder"
            onClick={isFocused && handleForceUnfocusClick}
            // if our SmartPortal is not rendered => we need to handle onClickOutside here
            // fix for weird behaviour in SDSUI-8436
            onClickOutside={!isFocused || showFieldControllerActions ? null : onClickOutside}
        >
            <div
                className={cx("field-controller", {
                    "is-focused": isFocused,
                    disabled,
                    "is-loading": isLoading,
                    "with-label": controllerLabelHeight,
                    "is-error": error && !disabled,
                })}
                data-field-key={fieldKey}
                onKeyDown={handleKeyDown}
                onFocus={handleFocus}
                ref={controllerRef}
                // title={error || (!isFocused && valueToCopy)}
                title={!isFocused && (error || valueToCopy)}
                tabIndex={-1}
                key={`${fieldKey}_saver`}
            >
                {isLoading && loader}
                {showFieldControllerActions && (
                    <SmartPortal
                        portalClassName={cx("field-controller-portal", {
                            [`widget-style-${widgetStyleClass}`]: !!widgetStyleClass,
                            ["fc-style-disabled"]: !!disabled,
                        })}
                        targetElement={controllerRef && controllerRef.current}
                        portalPlacement={portalPlacement}
                        portalKey={"SmartPortalFieldController"}
                        fieldKey={fieldKey}
                        withWidthOffset={["top", "bottom"].includes(portalPlacement)}
                        withoutRepositioning={["top", "bottom"].includes(portalPlacement)}
                        outerOffset={0}
                        outerXOffset={10}
                        outerYOffset={
                            ![null, undefined, ""].includes(customOuterYOffset)
                                ? customOuterYOffset
                                : (["left", "right"].includes(portalPlacement) && -1 * adjustedControllerLabelHeight) || // left and right position
                                  defaultYOffset
                        } // we need 5 here to properly center vertically due to
                        onPositionUpdate={onPositionUpdate}
                        // if our SmartPortal is rendered => we need to handle onClickOutside here
                        // fix for weird behaviour in SDSUI-8436
                        onClickOutside={showFieldControllerActions ? onClickOutside : null}
                        excludePortalHeightFromCalculations
                    >
                        <div className={`field-controller-buttons ${calculatedPortalPlacement}`}>
                            {isClearVisible && (
                                <div className="button-hover-circle" onClick={clearField}>
                                    <ReactSVG className="button-icon" src={`/data/svg/input_clear.svg`} />
                                </div>
                            )}
                            {isResetVisible && (
                                <div className="button-hover-circle" onClick={resetField}>
                                    <ReactSVG className="button-icon" src={`/data/svg/input_undo.svg`} />
                                </div>
                            )}
                            {isCopyVisible && (
                                <div className="button-hover-circle" onClick={handleCopyValue}>
                                    <ReactSVG className="button-icon" src={`/data/svg/input_copy.svg`} />
                                </div>
                            )}
                            {isSubmitVisible && (
                                <div
                                    className="button-hover-circle"
                                    onClick={submitField}
                                    data-field-controller-submit="true"
                                >
                                    <ReactSVG className="button-icon" src={`/data/svg/input_save.svg`} />
                                </div>
                            )}
                        </div>
                    </SmartPortal>
                )}
                {childrenWithProps}
                {error && !disabled && (isVisited || isFocused) && !preventErrorRender && (
                    <div
                        className={cx("field-controller-error", {
                            [widgetType]: CUSTOM_ERRORS_WIDGETS.includes(widgetType),
                        })}
                    >
                        {error}
                    </div>
                )}
                {/* {showDisabledPreviewValue && (
                    <SmartPortal
                        portalClassName={"field-controller-disabled-value-preview"}
                        targetElement={controllerRef && controllerRef.current}
                        portalPlacement={"bottom"}
                        portalKey={"SmartPortalDisabledValuePreview"}
                        fieldKey={`${fieldKey}_disabled_value_preview`}
                        withWidthOffset
                        // withoutRepositioning
                        withTargetWidth
                        outerOffset={0}
                        outerXOffset={14}
                        outerYOffset={0}
                    >
                        {valueToCopy}
                    </SmartPortal>
                )} */}
            </div>
        </ClickOutsideHolder>
    );
};

export default withTranslation()(FieldController);
